
export const PAKUTASO_TAG_ID_ALL = "すべて";
export const PAKUTASO_TAG_ID_街並み = "街並み";
export const PAKUTASO_TAG_ID_人物 = "人物";
export const PAKUTASO_TAG_ID_自然 = "自然";
export const PAKUTASO_TAG_ID_もの = "もの";

export const PAKUTASO_TAG_ID_LIST = [
  PAKUTASO_TAG_ID_ALL,
  PAKUTASO_TAG_ID_街並み,
  PAKUTASO_TAG_ID_人物,
  PAKUTASO_TAG_ID_自然,
  PAKUTASO_TAG_ID_もの,
] as const;

export type PakutasoTagId = typeof PAKUTASO_TAG_ID_LIST[number];


export interface PakutasoImage {
  title: string;
  thumbnail: string;
  url: string;
  tagIdList: PakutasoTagId[];
}


export interface PakutasoTag {
  id: PakutasoTagId;
  icon: string;
  iconDisabled: string;
}

